module.exports = __webpack_public_path__ + "static/companyComparisonTable-7385f298cddbf2f8177ff6853985ede2.png";